import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Navlink.module.scss";
/**
 * Sidebar nav row. Use `as="a"` for external links (href/target/rel) and the
 * default `as="button"` for in-app navigation — pass an `onClick` that calls
 * the router's `navigate()`. Do not wrap an `as="a"` Navlink in a router
 * `<Link>`: both render an `<a>`, producing invalid nested anchors.
 *
 * Anchor and button cases are separated in TS so each has the right native
 * attribute surface (target/rel vs type/disabled).
 */
export const Navlink = React.forwardRef((props, ref) => {
    const { icon, label, badge, active = false, className, ...rest } = props;
    const body = (_jsxs(_Fragment, { children: [icon && _jsx("span", { className: styles.icon, children: icon }), _jsx("span", { className: styles.label, children: label }), badge != null && _jsx("span", { className: styles.badge, children: badge })] }));
    if (props.as === "a") {
        const { as: _as, ...anchorRest } = rest;
        return (_jsx("a", { ref: ref, className: cn(styles.link, active && styles.active, className), ...anchorRest, children: body }));
    }
    const { as: _as, ...buttonRest } = rest;
    return (_jsx("button", { ref: ref, type: "button", className: cn(styles.link, active && styles.active, className), ...buttonRest, children: body }));
});
Navlink.displayName = "Navlink";
